import { render, staticRenderFns } from "./mobile_signer.vue?vue&type=template&id=5bc5d509&scoped=true&"
import script from "./mobile_signer.vue?vue&type=script&lang=js&"
export * from "./mobile_signer.vue?vue&type=script&lang=js&"
import style0 from "./mobile_signer.vue?vue&type=style&index=0&id=5bc5d509&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc5d509",
  null
  
)

export default component.exports